import { CustomerLead } from '../../core/domain/customerLead.model'
import AgentService from '../../core/services/agent.service'
import CustomerService from '../../core/services/customer.service'
import { LifecyclePresenter } from '../_components/ConnectComponent'
import { AdobeEventManager } from '../_utils/adobeAnalytics'
import { dataLayer } from '../_utils/adobeAnalytics/adobeAnalytics.conf'
import { fakeInitCustomer } from '../_utils/initializer'
import { goToHelvetiaLandingPage } from '../_utils/links'
import { ContactDataInfoValues, ContactMeRaw, View } from './ContactMe.view'

export class ContactMePresenter implements LifecyclePresenter<View> {
  private view!: ContactMeRaw
  private customer: CustomerLead
  private returnBackRouteTo: string

  initialize(view) {
    this.view = view
  }

  onLifecycleStart = async () => {
    await this.getCustomer()
    dataLayer.page.category.applicationStep = 'contactMe'
    AdobeEventManager.emit('contactMe_init', 'calc_step')

    this.view.setInitialValues({
      company: this.customer.company,
      firstName: this.customer.firstName,
      lastName: this.customer.lastName,
      email: this.customer.email,
      phone: this.customer.phone,
      acceptedPrivacyPolicy: this.customer.acceptedPrivacyPolicy,
    })
  }

  getCustomer = async () => {
    try {
      this.customer = await CustomerService.getCustomer()
    } catch (error) {
      console.log(error)
      this.customer = fakeInitCustomer
    }
  }

  onContinue = async (
    formValues: ContactDataInfoValues,
    hasReturnBackRoute: string,
  ) => {
    this.returnBackRouteTo = hasReturnBackRoute
    const customer = this.setFormValues(formValues)

    CustomerService.saveCustomer(customer).then(() => {
      CustomerService.contactMe().then(() => {
        AdobeEventManager.emit('contactMe_continue', 'direct_contact_to_agent')
        this.showViewModal()
      })
    })
  }

  setFormValues = (formValues: ContactDataInfoValues) => {
    return Object.assign(this.customer, {
      ...formValues,
      acceptedPrivacyPolicy: AgentService.isAgentOrBroker()
        ? true
        : Boolean(formValues.acceptedPrivacyPolicy),
    })
  }

  showViewModal = () => {
    this.view.showModal()
  }

  onHideModalHandler = () => {
    this.view.hideModal()

    if (this.returnBackRouteTo) {
      this.view.props.history.push(this.returnBackRouteTo)
    } else {
      // this.view.props.history.push('/home')
      this.view.showLoading()
      goToHelvetiaLandingPage()
    }
  }
}
